import { API_STATUS } from "core-lib/constants/network";
import { isEmptyNullUndefined } from "core-lib/utils/utils";
import ip from "icepick";
import { ReducerType } from "../types/Model";
import * as actions from "./type";

export const initialState: ReducerType = ip.freeze({
  amount: null,
  breakup: [],
  itemDetails: [],
  wallet: {
    enabled: false,
    isApplied: false,
  },
  promo: {
    enabled: false,
    autoApply: false,
  },
  addOns: [],
  tip: null,

  showPromoPopup: false,
  showPromoSuccess: false,
  wasLastPromoSuccessful: false,
  isPromoValidating: false,
  validatedPromo: null,
  appliedPromo: null,

  origin: {
    source: null,
    data: null,
  },

  selectedMethod: null,
  methodList: [],
  bankList: [],
  isPaymentReady: false,
  lastUsed: null,

  orderData: null,

  walletBalance: null,
  summary: null,

  showMethodPopup: false,
  invalidPromoMsg: null,
  promoErrorPopup: null,
  showExistingCardPopup: false,
  showMethodChangeTooltip: false,
  userCardData: null,
  autoPay: {
    isAvailable: false,
    isSelected: false,
    methodData: null,
  },

  orderListing: {
    page: 1,
    hasMore: true,
    apiStatus: API_STATUS.default,
    data: [],
  },

  fullfilmentDetails: {},
});

export function paymentReducer(state = initialState, action) {
  switch (action.type) {
    case actions.SET_PAYMENT_DATA: {
      const {
        amount,
        itemDetails,
        breakup,
        wallet,
        promo,
        isPromoValidating,
        validatedPromo,
        appliedPromo,
        selectedMethod,
        orderData,
        methodList,
        bankList,
        lastUsed,
        addOns,
        isPaymentReady,
        origin,
        showMethodPopup,
        showExistingCardPopup,
        showMethodChangeTooltip,
        invalidPromoMsg,
        tip,
        summary,
        walletBalance,
        userCardData,
        wasLastPromoSuccessful,
        showPromoPopup,
        showPromoSuccess,
        promoErrorPopup,
        fullfilmentDetails,
      } = action.payload;
      if (amount !== undefined) state = ip.setIn(state, ["amount"], amount);
      if (itemDetails) state = ip.setIn(state, ["itemDetails"], itemDetails);
      if (breakup) state = ip.setIn(state, ["breakup"], breakup);
      if (wallet) state = ip.setIn(state, ["wallet"], wallet);
      if (promo) state = ip.setIn(state, ["promo"], promo);
      if (summary) state = ip.setIn(state, ["summary"], summary);
      if (walletBalance)
        state = ip.setIn(state, ["walletBalance"], walletBalance);
      if (selectedMethod !== undefined)
        state = ip.setIn(state, ["selectedMethod"], selectedMethod);
      if (orderData !== undefined)
        state = ip.setIn(state, ["orderData"], orderData);
      if (methodList) state = ip.setIn(state, ["methodList"], methodList);
      if (bankList) state = ip.setIn(state, ["bankList"], bankList);
      if (lastUsed) state = ip.setIn(state, ["lastUsed"], lastUsed);
      if (userCardData !== undefined)
        state = ip.setIn(state, ["userCardData"], userCardData);
      if (isPaymentReady !== undefined)
        state = ip.setIn(state, ["isPaymentReady"], isPaymentReady);
      if (invalidPromoMsg !== undefined)
        state = ip.setIn(state, ["invalidPromoMsg"], invalidPromoMsg);
      if (promoErrorPopup !== undefined)
        state = ip.setIn(state, ["promoErrorPopup"], promoErrorPopup);
      if (origin) state = ip.setIn(state, ["origin"], origin);
      if (isPromoValidating !== undefined)
        state = ip.setIn(state, ["isPromoValidating"], isPromoValidating);
      if (appliedPromo !== undefined)
        state = ip.setIn(state, ["appliedPromo"], appliedPromo);
      if (addOns !== undefined) state = ip.setIn(state, ["addOns"], addOns);
      if (validatedPromo !== undefined)
        state = ip.setIn(state, ["validatedPromo"], validatedPromo);
      if (showMethodPopup !== undefined)
        state = ip.setIn(state, ["showMethodPopup"], showMethodPopup);
      if (showExistingCardPopup !== undefined)
        state = ip.setIn(
          state,
          ["showExistingCardPopup"],
          showExistingCardPopup
        );
      if (showMethodChangeTooltip !== undefined)
        state = ip.setIn(
          state,
          ["showMethodChangeTooltip"],
          showMethodChangeTooltip
        );
      if (tip !== undefined) state = ip.setIn(state, ["tip"], tip);
      if (showPromoPopup !== undefined)
        state = ip.setIn(state, ["showPromoPopup"], showPromoPopup);
      if (showPromoSuccess !== undefined)
        state = ip.setIn(state, ["showPromoSuccess"], showPromoSuccess);
      if (wasLastPromoSuccessful !== undefined) {
        state = ip.setIn(
          state,
          ["wasLastPromoSuccessful"],
          wasLastPromoSuccessful
        );
      }
      if (fullfilmentDetails !== undefined) {
        state = ip.setIn(state, ["fullfilmentDetails"], fullfilmentDetails);
      }
      return state;
    }

    case actions.UPDATE_AUTO_PAY: {
      const { isAvailable, isSelected, methodData } = action.payload;
      if (!isEmptyNullUndefined(isAvailable)) {
        state = ip.setIn(state, ["autoPay", "isAvailable"], isAvailable);
      }
      if (!isEmptyNullUndefined(methodData)) {
        state = ip.setIn(state, ["autoPay", "methodData"], methodData);
      }
      if (!isEmptyNullUndefined(isSelected)) {
        state = ip.setIn(state, ["autoPay", "isSelected"], isSelected);
        if (isSelected) {
          state = ip.setIn(state, ["selectedMethod"], state.autoPay.methodData);
        }
      }
      return state;
    }
    case actions.UPDATE_ORDER_LISTING: {
      const { page, hasMore, apiStatus, data } = action.payload;
      if (page) {
        state = ip.setIn(state, ["orderListing", "page"], page);
      }
      if (!isEmptyNullUndefined(hasMore)) {
        state = ip.setIn(state, ["orderListing", "hasMore"], hasMore);
      }
      if (!isEmptyNullUndefined(apiStatus)) {
        state = ip.setIn(state, ["orderListing", "apiStatus"], apiStatus);
      }
      if (!isEmptyNullUndefined(data)) {
        state = ip.setIn(state, ["orderListing", "data"], data);
      }
      return state;
    }

    case actions.RESET_PAYMENT_DATA: {
      state = ip.setIn(state, ["amount"], initialState.amount);
      state = ip.setIn(state, ["breakup"], initialState.breakup);
      state = ip.setIn(state, ["wallet"], initialState.wallet);
      state = ip.setIn(state, ["promo"], initialState.promo);
      state = ip.setIn(state, ["addOns"], initialState.addOns);
      state = ip.setIn(
        state,
        ["isPromoValidating"],
        initialState.isPromoValidating
      );
      state = ip.setIn(
        state,
        ["showPromoSuccess"],
        initialState.showPromoSuccess
      );
      state = ip.setIn(state, ["validatedPromo"], initialState.validatedPromo);
      state = ip.setIn(state, ["appliedPromo"], initialState.appliedPromo);
      state = ip.setIn(state, ["origin"], initialState.origin);
      state = ip.setIn(state, ["selectedMethod"], initialState.selectedMethod);
      state = ip.setIn(state, ["methodList"], initialState.methodList);
      state = ip.setIn(state, ["bankList"], initialState.bankList);
      state = ip.setIn(state, ["lastUsed"], initialState.lastUsed);
      state = ip.setIn(state, ["userCardData"], initialState.userCardData);
      state = ip.setIn(
        state,
        ["invalidPromoMsg"],
        initialState.invalidPromoMsg
      );
      state = ip.setIn(state, ["orderData"], initialState.orderData);
      state = ip.setIn(state, ["walletBalance"], initialState.walletBalance);
      state = ip.setIn(state, ["summary"], initialState.summary);
      state = ip.setIn(
        state,
        ["showMethodPopup"],
        initialState.showMethodPopup
      );
      state = ip.setIn(
        state,
        ["showExistingCardPopup"],
        initialState.showExistingCardPopup
      );
      state = ip.setIn(
        state,
        ["showMethodChangeTooltip"],
        initialState.showMethodChangeTooltip
      );
      state = ip.setIn(
        state,
        ["wasLastPromoSuccessful"],
        initialState.wasLastPromoSuccessful
      );
      return state;
    }

    default:
      return state;
  }
}
